import {
  getAllCarriersFromCarrierConfigurations,
  getAllCompanies,
} from "../../../Components/Selects/AsyncSelect/api";
import { useAppContext } from "../../../AppProvider";
import {
  getCarrierConfigurationOptionStyle,
  getCompanyOptionStyle,
} from "../../../Components/Selects/AsyncSelect/styles";
import { getGenerateNumberObjects } from "../../../utilities/utilities";
import {
  faArrowDownShortWide,
  faArrowUpShortWide,
} from "../../../utilities/fontawesomeIcons";
import moment from "moment";
import Rating from "../../../Components/Rating/Rating";

export const useListProps = () => {
  const { dictionary } = useAppContext();
  const ratings = getGenerateNumberObjects(1, 5);

  return {
    path: `/registry-service/feedbacks`,
    banner: {
      enabled: true,
    },
    type: "grid",
    selectRowsEnabled: { enabled: false },
    sorting: [
      {
        orderBy: "desc",
        column: "date",
        icon: faArrowDownShortWide,
        label: dictionary.dates.date,
        isDefault: true,
      },
      {
        orderBy: "asc",
        column: "date",
        icon: faArrowUpShortWide,
        label: dictionary.dates.date,
        isDefault: false,
      },
      {
        orderBy: "desc",
        column: "rating",
        icon: faArrowDownShortWide,
        label: dictionary.feedbacks.rating,
        isDefault: true,
      },
      {
        orderBy: "asc",
        column: "rating",
        icon: faArrowUpShortWide,
        label: dictionary.feedbacks.rating,
        isDefault: false,
      },
    ],
    omnisearch: {
      enabled: true,
      placeholder: dictionary.actions.search,
    },
    pagination: { enabled: true },
    title: dictionary.contracts.contracts,
    defaultDate: {
      enabled: true,
      fieldName: "date",
      label: dictionary.dates.date,
      value: [
        moment().subtract(1, "months").startOf("day").toDate(),
        moment().endOf("day").toDate(),
      ],
    },

    filters: {
      name: "feedbacks",
      preserve: false,
      list: [
        {
          fieldName: "ownerId",
          label: dictionary.registries.owner,
          type: "async-select",
          isMulti: true,
          loadOptions: (searchValue, pagination) => {
            const params = {
              inputValue: searchValue,
              pagination,
              sorting: { selector: "name", orderBy: "asc" },
            };
            return getAllCompanies(params);
          },
          optionStyle: (option) => {
            const CompanyOption = getCompanyOptionStyle(option);
            return <CompanyOption />;
          },
          primary: true,
          col: 3,
        },
        {
          fieldName: "carrierCode",
          searchKey: "carrierCode",
          label: dictionary.registries.carriers,
          type: "async-select",
          isMulti: true,
          loadOptions: (searchValue, pagination) => {
            const params = {
              inputValue: searchValue,
              pagination,
              sorting: { selector: "name", orderBy: "asc" },
            };
            return getAllCarriersFromCarrierConfigurations(params);
          },
          optionStyle: (option) => {
            const CarrierConfigurationOption =
              getCarrierConfigurationOptionStyle(option);
            return <CarrierConfigurationOption />;
          },
          primary: true,
          col: 3,
        },
        {
          fieldName: "rating",
          label: dictionary.feedbacks.rating,
          type: "select",
          isMulti: true,
          options: ratings,
          optionStyle: (option) => (
            <Rating value={option.value} hidden={true} />
          ),
          primary: true,
          col: 3,
        },
      ],
    },
  };
};
